import _ from 'lodash';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import { connect } from 'react-redux';
import LockOpenOutlined from '@material-ui/icons/LockOpenOutlined';
import * as LockActions from '../../redux/actions/lock.actions';
import EmptyView from '../EmptyView.jsx';
import ListLoadingView from '../ListLoadingView.jsx';
import LockDetailsRow from './LockDetailsRow.jsx';
import SmartLocksEventsIconCustom from '../CustomIcons/SmartLocksEventsIconCustom.jsx';
import { Card, useMediaQuery, useTheme } from '@material-ui/core';
import { getLockImage } from '../../_config/utils.js';
import { LockOpen } from '@material-ui/icons';
import MDButton from '../MDButton/MDButton.jsx';
import { ACCESSORIES_TYPES, BLUE, GREEN, SMARTLOCK_DOOR_STATUS, SMARTLOCK_DOOR_STATUS_MAP } from '../../_config/consts.js';

// Componente helper per l'icona del lock
const LockIcon = ({ model }) => (
  <div style={{
    marginRight: 15
  }}>
      <img 
        style={{ 
          width: 60, 
          height: 60, 
          objectFit: 'cover',
          borderRadius: '50%',
          display: 'block'
        }} 
        src={getLockImage(model)} 
        alt="lock"
      />
  </div>
);

// Componente helper per il testo del lock
const LockText = ({ name, serialNumber }) => (
  <div style={{ display: 'flex', flexDirection: 'column' }}>
    <h4 style={{ 
      margin: 0, 
      color: '#3f3f3f', 
      fontSize: '16px',
      fontWeight: 'bold'
    }}>
      {name}
    </h4>
    <h5 style={{ 
      margin: 0, 
      marginTop: 5,
      color: '#3f3f3f', 
      fontSize: '14px',
      fontWeight: 'normal'
    }}>
      {serialNumber}
    </h5>
  </div>
);

// Componente helper per il pulsante APRI
const OpenButton = ({ onClick, isMobile = false }) => {
  const baseStyle = {
    backgroundColor: GREEN,
    color: 'white',
    border: 'none',
    fontSize: '14px',
    fontWeight: 'bold',
    cursor: 'pointer',
    textTransform: 'uppercase'
  };

  const mobileStyle = {
    ...baseStyle,
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 60
  };

  const desktopStyle = {
    ...baseStyle,
    padding: '15px 25px',
    minWidth: 180,
    borderRadius: 5
  };

  return (
    <button
      onClick={onClick}
      style={isMobile ? mobileStyle : desktopStyle}
    >
      <span>{L20NContext.getSync('openLock')}</span>
    </button>
  );
};

// Componente helper per il pulsante TOGGLE PASSAGE
const TogglePassageButton = ({ onClick, isMobile = false, isLast = false }) => {
  const baseStyle = {
    backgroundColor: BLUE,
    color: 'white',
    border: 'none',
    fontSize: '14px',
    fontWeight: 'bold',
    cursor: 'pointer',
    textTransform: 'uppercase'
  };

  const mobileStyle = {
    ...baseStyle,
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 60
  };

  const desktopStyle = {
    ...baseStyle,
    padding: '15px 25px',
    minWidth: 180,
    borderRadius: 5,
    marginRight: 20,
    marginLeft: 20
  };

  return (
    <button
      onClick={onClick}
      style={isMobile ? mobileStyle : desktopStyle}
    >
      <span style={{ marginRight: 10 }}>{L20NContext.getSync('togglePassageMode')}</span>
    </button>
  );
};

// Componente helper per la sezione icona e testo
const LockInfoSection = ({ model, name, serialNumber, passageModeState, doorStatusVariables, isMobile = false }) => (
  <div style={{ 
    display: 'flex', 
    flexDirection: 'row', 
    alignItems: 'center', 
    padding: 20,
    flex: isMobile ? undefined : 1
  }}>
    <LockIcon model={model} />
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      <LockText name={name} serialNumber={serialNumber} />
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', marginTop: 5 }}>
        {passageModeState !== "OFF" ?
          <LockOpenOutlined
            data-tip={L20NContext.getSync('passageMode')}
            style={{ fontSize: 18, opacity: 1, marginRight: 5, color: GREEN }}
          />
        : null}
        {doorStatusVariables && doorStatusVariables.icon}
      </div>
    </div>
  </div>
);

const RemoteOpenLockRow = ({ lock: { model, name, serialNumber, passageModeState, accessories }, onClick, onSetPassageModeLockByGateway }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const lockSensor = accessories ? _.find(accessories, accessory => accessory.type === ACCESSORIES_TYPES.DOOR_SENSOR) : null;
  let doorStatusVariables;
  if (lockSensor) {
    doorStatusVariables = lockSensor.value && SMARTLOCK_DOOR_STATUS_MAP[lockSensor.value] ? SMARTLOCK_DOOR_STATUS_MAP[lockSensor.value] : SMARTLOCK_DOOR_STATUS_MAP[SMARTLOCK_DOOR_STATUS.UNKNOWN];
  }

  // Layout Desktop (orizzontale)
  if (!isMobile) {
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'row', 
        alignItems: 'stretch',
        backgroundColor: 'white',
        borderRadius: 10,
        marginBottom: 10,
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        overflow: 'hidden',
        minHeight: 80
      }}>
        <LockInfoSection 
          model={model} 
          name={name} 
          serialNumber={serialNumber} 
          passageModeState={passageModeState}
          doorStatusVariables={doorStatusVariables}
        />
        
        {/* Pulsanti */}
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <OpenButton onClick={onClick} />
          {onSetPassageModeLockByGateway && (
            <TogglePassageButton 
              onClick={onSetPassageModeLockByGateway} 
              isLast={true}
            />
          )}
        </div>
      </div>
    );
  }

  // Layout Mobile (verticale)
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column',
      backgroundColor: 'white',
      borderRadius: 10,
      marginBottom: 15,
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      overflow: 'hidden'
    }}>
      <LockInfoSection 
        model={model} 
        name={name} 
        serialNumber={serialNumber} 
        passageModeState={passageModeState}
        doorStatusVariables={doorStatusVariables}
        isMobile={true} 
      />

      {/* Sezione inferiore con pulsanti */}
      <div style={{ 
        display: 'flex', 
        flexDirection: 'row',
        minHeight: 60
      }}>
        <OpenButton onClick={onClick} isMobile={true} />
        
        {/* Separatore verticale */}
        <div style={{ width: 1, backgroundColor: 'white' }}></div>
        
        {onSetPassageModeLockByGateway && (
          <TogglePassageButton 
            onClick={onSetPassageModeLockByGateway} 
            isMobile={true}
          />
        )}
      </div>
    </div>
  );
}


const LockRemoteOpenListView = connect((state) => ({
  locks: state.locks,
  viewLoading: state.utils.viewLoading,
  themeName: state.settings.items.theme.data.themeName,
}))(({ locks: { remoteOpenSmartLocks }, listContainerStyle, onOpenLock, viewLoading, onSelectLock, onSetPassageModeLockByGateway }) => {
  return (
    <div style={{ 
      height: '115vh', 
      overflow: 'auto', 
      padding: 15,
      paddingBottom: 30,
      display: 'flex',
      flexDirection: 'column'
    }}>
      <div style={{ flex: 1 }}>
        {!_.isEmpty(remoteOpenSmartLocks) ?
          _.map(_.sortBy(remoteOpenSmartLocks, 'id'), lock =>
            <RemoteOpenLockRow
              key={lock.id}
              lock={lock}
              onSetPassageModeLockByGateway={onSetPassageModeLockByGateway ? () => onSetPassageModeLockByGateway(lock) : null}
              onClick={() => onOpenLock(lock)}
            />) : (
              <div>
                {!viewLoading ? (
                  <EmptyView
                    title="noLockCredential"
                    subtitle="verifyLockCredential"
                    icon={<SmartLocksEventsIconCustom style={{ color: '#a5a3a3', width: 50 }} />}
                    containerStyle={{ paddingLeft: 30, paddingRight: 30}}
                  />) : <ListLoadingView />}
              </div>
              )
          }
        </div>
      </div>
  );
});

export default LockRemoteOpenListView;